module.exports = __webpack_public_path__ + "img/color6.14a58c8e.png";